import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const QuestionsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  border-bottom: 1px solid ${theme.colours.AntiFlashWhite};
 
  .iconSection {
    width: 24px;
    height: 24px;
    border-radius: 50px;
    background-color: ${theme.colours.Cultured};
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 767px) {
    padding: 0;
  }

  .questionSection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    p {
      font-size: 14px;
      font-family: ${theme.fonts.Regular};
      color: ${theme.colours.black_2};
      line-height: 22px;
    }
  }

  .answerSection {
    p,
    li {
      font-size: 14px;
      font-family: ${theme.fonts.Regular};
      font-weight: 400;
      color: ${theme.colours.black_2};
      line-height: 20px;
    }
    li {
      list-style: none;
    }
  }
`;
